import { Undefinable } from "@core/domain/types/undefinable.type";

export class CreateEntityApiKey {
    constructor(
        public readonly entityId: Undefinable<number>,
        public readonly name: string,
        public readonly scopes: string[],
        public readonly isActive: boolean,
    ) {}
}
